export default function Show({ when, fallback, children, }) {
    const shouldShow = typeof when === 'function' ? when() : when;
    return (shouldShow ? children : fallback ?? false);
}
